// extracted by mini-css-extract-plugin
export default {"expand-button":"iV38UOdnidzfX3SkU1s_","expanded":"vOxdB9KK5PKni4y5NGtE"};